var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 100,
    viewBox: "0 0 229 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_184_867",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 229,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228.934,
    height: 100,
    transform: "matrix(1 0 0 -1 0 100)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_184_867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.589 1.52588e-05H229.188C208.952 25.2554 181.021 45.7266 150.991 51.6801C133.063 55.2375 114.621 54.7516 96.7817 54.274C84.6806 53.9529 72.1702 53.6235 59.9872 54.5705C42.9072 55.8962 1.424 62.8215 -14.7927 98.4772L-18.7817 96.2538C-1.53799 58.3337 41.8281 51.0296 59.6746 49.638C72.066 48.6745 84.6881 49.0121 96.8859 49.3333C114.502 49.8027 132.713 50.2803 150.202 46.8135C179.242 41.0576 203.016 24.432 222.589 1.52588e-05Z",
    fill: "white",
    fillOpacity: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1);
export default __webpack_public_path__ + "static/media/footer_1.ee6d50319855aa40aa2b54ba0a642472.svg";
export { ForwardRef as ReactComponent };